import { getDeviceId, whenReady } from './amplitude'

const initGoogleAnalytics = async () => {
  // settles once Amplitude is ready or off — without a device id GA is configured without user_id
  await whenReady()
  const deviceId = getDeviceId()

  window.dataLayer = window.dataLayer || []
  function gtag () { window.dataLayer.push(arguments) }

  gtag('js', new Date())

  setTimeout(() => {
    gtag('config', 'G-TDTST7GX0W', deviceId ? { user_id: deviceId } : {})
  }, 50)
}

initGoogleAnalytics()
